import PropTypes from 'prop-types';

import GenericFormContainer from '../Forms/GenericFormContainer';

import {
  lengthValidation120,
  maxFileSize,
  notNullOrUndefined,
  required,
} from '../Forms/utils';

import {
  CHECKBOX,
  EXPANDABLE_IMAGE_COMPONENT,
  IMAGE_UPLOAD,
  REACT_SELECT_INPUT,
  STYLED_TEXT,
} from '../Forms/fieldTypes';

const DeliveryTypesFormComponent = ({
  countriesOptions,
  isCreate,
  form,
  onSubmit,
  initialValues,
  onLoad,
}) => {
  const iconUrl = initialValues?.icons?.[0]?.url;

  const formData = [
    {
      keyName: 'icon',
      label: 'icon',
      fieldType: EXPANDABLE_IMAGE_COMPONENT,
      src: iconUrl,
      height: '10rem',
      isHidden: !iconUrl,
    },
    {
      keyName: 'name',
      label: 'Name',
      fieldType: STYLED_TEXT,
      validate: [required, lengthValidation120],
    },
    {
      keyName: 'enabled',
      label: 'Is Enabled',
      fieldType: CHECKBOX,
      validate: [notNullOrUndefined],
    },
    {
      keyName: 'initialValueForBuildings',
      label: 'Defaulted on for all buildings',
      fieldType: CHECKBOX,
      validate: [notNullOrUndefined],
    },
    {
      keyName: 'countries',
      label: 'Countries (leave empty to enable this type for all countries)',
      fieldType: REACT_SELECT_INPUT,
      options: countriesOptions,
      multi: true,
      validate: [],
    },

    {
      keyName: 'icons',
      label: 'Delivery Type Icon',
      fieldType: IMAGE_UPLOAD,
      validate: [maxFileSize],
      isHidden: !isCreate,
    },
    {
      label: 'Remove Icon',
      keyName: 'removeIcon',
      fieldType: CHECKBOX,
      validate: [],
      isHidden: !iconUrl || true, // not supported by API at this point
    },
  ];

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      initialValues={initialValues}
      onLoad={onLoad}
      title={`${isCreate ? 'Add' : 'Update'} Delivery Type`}
      backButton
      submitText="Save"
    />
  );
};

DeliveryTypesFormComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  onLoad: PropTypes.func.isRequired,
  countriesOptions: PropTypes.instanceOf(Array).isRequired,
  isCreate: PropTypes.bool.isRequired,
};

export default DeliveryTypesFormComponent;
